export {TRANSLATION_NL} from './nl';
